import { AssistanceAndLanguagePage } from '@leagueplatform/highmark-common';
import { StaticPageWrapper } from './static-page-wrapper.component';

export const AllMyHealthLanguagePage = () => (
  <StaticPageWrapper>
    <AssistanceAndLanguagePage />
  </StaticPageWrapper>
);
